"use strict";

var TokenIterator = require("./TokenIterator");
exports.Parser = function (options) {
  var parseTokens = function parseTokens(parser, tokens) {
    return parser(new TokenIterator(tokens));
  };
  return {
    parseTokens: parseTokens
  };
};